import { fork, all } from 'redux-saga/effects'
import apiSaga from "./apiSaga"
import fileUploadSaga from "./fileUploadSaga"
import fileDownloadSaga from "./fileDownloadSaga"

export default function* root() {
    yield all([
        fork(apiSaga),
        fork(fileUploadSaga),
        fork(fileDownloadSaga),
    ])
}


// WEBPACK FOOTER //
// ./src/saga/index.js